import { Tag } from 'antd';
import { PlusOutlined, CheckOutlined } from '@ant-design/icons';

interface SelectiveTagProps {
  selectedTags: string[];
  tagKey: string;
  tagLabel: string;
  handleChange: (tagKey: string, checked: boolean) => void;
}

export const SelectiveTag = ({
  tagLabel,
  selectedTags,
  tagKey,
  handleChange,
}: SelectiveTagProps) => {
  return (
    <Tag.CheckableTag
      className={`rounded-full py-1 px-3 cursor-pointer flex gap-1 text-base font-light hover:text-[#2BB45D]
          ${selectedTags.includes(tagKey) ? 'bg-white border-[#2BB45D] text-[#2BB45D] hover:border-white' : 'bg-gray-200'}`}
      key={tagKey}
      checked={selectedTags.includes(tagKey)}
      onChange={(checked) => handleChange(tagKey, checked)}
    >
      {tagLabel}
      {selectedTags.includes(tagKey) ? <CheckOutlined /> : <PlusOutlined />}
    </Tag.CheckableTag>
  );
};
